import { ILottieAnimationProps } from 'components/animation';
import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';

export const Animation: LazyComponent<Omit<ILottieAnimationProps, 'options'>> =
  lazyWithNullFallback(() => import('./favorite-loading'));
